import { render, staticRenderFns } from "./AttachmentsCustomer.vue?vue&type=template&id=1a302fee&"
import script from "./AttachmentsCustomer.vue?vue&type=script&lang=js&"
export * from "./AttachmentsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports